import { RegionName, RegionNames } from '@packages/types/nds/region';

export const PARTITION_ATTRIBUTE_TYPES = ['string', 'int', 'isodate', 'epoch_secs', 'epoch_millis', 'objectid', 'uuid'];
export const DLS_AWS_STORE_NAME = 'aws-dls-store';
export const DEFAULT_AWS_REGION: RegionName = RegionNames.US_EAST_1;
export const WILDCARD = '*';
